const USER_HAS_READ_TIMEOUT = 5000
const READ_ITEMS_LIMIT = 50
const LOCAL_STORAGE_KEY_READ = 'app:readItems'

export const useReadItems = () => {
  const getReadList = (): string[] => {
    const storedValue = localStorage.getItem(LOCAL_STORAGE_KEY_READ)
    return storedValue ? JSON.parse(storedValue) : []
  }

  const saveReadList = (list: string[]) => {
    localStorage.setItem(LOCAL_STORAGE_KEY_READ, JSON.stringify(list))
  }

  const addReadItem = (id: string) => {
    const readList = getReadList()
    if (!readList.includes(id)) {
      readList.unshift(id)
      if (readList.length > READ_ITEMS_LIMIT) {
        readList.pop()
      }
      saveReadList(readList)
    }
  }

  const isItemRead = (id: string): boolean => {
    const readList = getReadList()
    return readList.includes(id)
  }

  const sortItemsByReadStatus = <T extends { id: string }>(items: T[]): T[] => {
    return items.slice().sort((a, b) => {
      const aRead = isItemRead(a.id)
      const bRead = isItemRead(b.id)
      return aRead === bRead ? 0 : aRead ? 1 : -1
    })
  }

  const trackReadItem = (
    articleId: string | undefined,
    visibility: Ref<string>
  ) => {
    let timer: ReturnType<typeof setTimeout> | null = null

    const markAsRead = () => {
      if (articleId) addReadItem(articleId)
    }

    watch(
      visibility,
      (currentVisibility) => {
        if (currentVisibility !== 'visible' && timer) {
          clearTimeout(timer)
          timer = null
          return
        }
        if (!timer) {
          timer = setTimeout(() => {
            markAsRead()
            timer = null
          }, USER_HAS_READ_TIMEOUT)
        }
      },
      { immediate: true }
    )
  }

  return {
    addReadItem,
    isItemRead,
    sortItemsByReadStatus,
    trackReadItem,
  }
}
